import { OrderItem } from '@leid/api-orders'

import { parseUtcToMoment } from 'utils/dates'

export const getOrderItemFromDate = (orderItem: OrderItem): Date | undefined => {
  const fromDate = parseUtcToMoment(orderItem.rentedFrom)?.subtract(15, 'minutes')
  return fromDate?.toDate()
}

export const getOrderItemToDate = (orderItem: OrderItem): Date | undefined => {
  const toDate = parseUtcToMoment(orderItem.rentedTo)?.add(15, 'minutes')
  return toDate?.toDate()
}
